<template>
  <div class="news-poster">
    <img :src="img" v-if="img" alt="">
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="less">
.news-poster {
	width: 100%;
	//height: 460px;
	background-color: #F9F9F9;
	background-image: url('/news.svg');
	background-size: 79px 79px;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 15px;
	overflow: hidden;

	//@media screen and (max-width: 1200px) { height: 375px; }
	//@media screen and (max-width: 992px) { height: 500px; }

	img {
		width: 100%;
		height: auto;
		//object-fit: cover;
		//object-position: center;
	}
}
</style>
